import { useState, useCallback } from 'react';
import { updateInvoiceStatus } from '../services/updateInvoiceStatusService';

export function useUpdateInvoiceStatus(userId) {
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateError, setUpdateError] = useState(null);

  const updateStatus = useCallback(
    async (companyInvoiceId, status) => {
      setIsUpdating(true);
      setUpdateError(null);
      try {
        const result = await updateInvoiceStatus({ userId, companyInvoiceId, status });
        return result;
      } catch (err) {
        setUpdateError(err);
        return null;
      } finally {
        setIsUpdating(false);
      }
    },
    [userId],
  );

  const resetUpdateError = useCallback(() => setUpdateError(null), []);

  return { isUpdating, updateError, updateStatus, resetUpdateError };
}
